import { LANGUAGE } from './language.constant'

export const LANGUAGES = Object.values(LANGUAGE)